import { Card, Carousel, Icon, Space, Typography } from '@sravni/react-design-system';
import type {
  IconColor,
  IconBackground,
} from '@sravni/react-design-system/dist/types/components/Icon/types/Icon.types';
import { ArrowRight } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';

import { FIN_ORG_URL, FinPlatformItems } from '../constants';
import { FinPlatformTexts } from '../FinPlatform.texts';

import styles from './FinPlatform.module.scss';

export const FinPlatform = () => {
  const isMobile = useIsMobile();

  return (
    <div className={styles.finPlatform}>
      <Typography.Heading
        level={3}
        className={styles.title}
        as="h2"
      >
        {FinPlatformTexts.title}
      </Typography.Heading>
      <Typography.Text
        className="h-mt-8"
        size={14}
      >
        {FinPlatformTexts.subTitle}
      </Typography.Text>

      <Space
        className={isMobile ? 'h-mt-16' : 'h-mt-32'}
        direction={isMobile ? 'column' : 'row'}
        justify="space-between"
        size={16}
      >
        <Card
          color="blue"
          variant="secondary"
        >
          <Typography.Text>{FinPlatformTexts.federalLawNotice}</Typography.Text>
        </Card>
        <div className={styles.block}>
          <Typography.Text>{FinPlatformTexts.finOrgText}</Typography.Text>
          <Typography.Link
            className={styles.link}
            href={FIN_ORG_URL}
            target="_blank"
          >
            {FinPlatformTexts.finOrgUrlLabel}{' '}
            <Icon
              className="h-ml-4"
              icon={<ArrowRight />}
            />
          </Typography.Link>
        </div>
      </Space>

      <Carousel className={isMobile ? 'h-mt-16' : 'h-mt-32'}>
        {FinPlatformItems.map((item) => (
          <Space
            direction="column"
            className={styles.card}
            key={item.title}
          >
            <Icon
              shape="round"
              color={item.color as IconColor}
              background={item.color as IconBackground}
              icon={item.icon}
            />
            <Typography.Text
              className="h-mt-16"
              strong
            >
              {item.title}
            </Typography.Text>
            <Space
              size={48}
              direction="column"
              justify="space-between"
            >
              <Typography.Text className="h-mt-12">{item.text}</Typography.Text>
              {item?.link && (
                <Typography.Link
                  className={styles.link}
                  href={item.link}
                  target="_blank"
                >
                  {item.linkLabel}{' '}
                  {item.linkIcon && (
                    <Icon
                      className="h-ml-4"
                      icon={<ArrowRight />}
                    />
                  )}
                </Typography.Link>
              )}
            </Space>
          </Space>
        ))}
      </Carousel>
    </div>
  );
};
